var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var Exit20 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '20px' : _c, _d = _a.width, width = _d === void 0 ? '20px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 20 20", style: svgStyle },
            React.createElement("g", { id: "Exit/20" },
                React.createElement("path", { id: "Combined Shape", clipRule: "evenodd", d: "M9.29293 10L2.64648 3.35356L3.35359 2.64645L10 9.2929L16.6465 2.64645L17.3536 3.35356L10.7071 10L17.3536 16.6465L16.6465 17.3536L10 10.7071L3.35359 17.3536L2.64648 16.6465L9.29293 10Z" })))));
};
Exit20.displayName = 'Exit20';
export default Exit20;
//# sourceMappingURL=exit-20.js.map